// extracted by mini-css-extract-plugin
export default {"container":"service_container__LdNxV"};